import { useDeleteGlobalNotificationMutation, useGlobalNotificationsQuery } from "@/common/queries/queries";
import { useEffect, useState } from "react";
import { IGlobalNotification } from "@/common/services/types";
import { InfoBar } from "./InfoBar";
import { metricsBus } from "@/common/buses";
import { useUserStore } from "@/common/store/userStore";
import { setAnonymousNotification, loadAnonymousNotification } from "@/common/utils/storage";
import { useLessNavigation } from "@/common/hooks/useLessNavigation";

export const InfoBarContainer = () => {
  const currentUserName = useUserStore((state) => state.currentUser?.username);
  const [notification, setNotification] = useState<IGlobalNotification | null>(null);
  const [showNotify, setShowNotify] = useState<boolean>(true);
  const { isSuccess, data } = useGlobalNotificationsQuery(currentUserName);
  const deleteGlobalNotification = useDeleteGlobalNotificationMutation(currentUserName);
  const { canShow } = useLessNavigation();
  const anonymousNotification = loadAnonymousNotification() || [];

  useEffect(() => {
    if (isSuccess && data) {
      setNotification(data.global[0]);
    }
  }, [isSuccess, data]);

  const sendDeleteNotification = async (id: string) => {
    try {
      await deleteGlobalNotification.mutateAsync(id);
    } catch (err) {
      console.error(err);
    }
  };

  const onLinkAction = async (id: string) => {
    metricsBus.emit("infoBarClicked");
    if (currentUserName) {
      await sendDeleteNotification(id);
    } else {
      setAnonymousNotification([...anonymousNotification, id]);
    }
    setShowNotify(false);
  };

  const onCloseInfoBar = async (id: string) => {
    metricsBus.emit("infoBarClosed");
    setShowNotify(false);
    if (currentUserName) {
      await sendDeleteNotification(id);
    } else {
      setAnonymousNotification([...anonymousNotification, id]);
    }
  };

  if (
    !notification ||
    !canShow ||
    (!currentUserName && (anonymousNotification.includes(notification.id)))
  ) {
    return null;
  }

  return (
    <InfoBar
      showNotify={showNotify}
      onLinkAction={onLinkAction}
      onCloseInfoBar={onCloseInfoBar}
      notification={notification}
    />
  );
};

export default InfoBarContainer;
